<template>
  <v-app-bar
    app
    color="primary"
    :src="trip.image || undefined"
    shrink-on-scroll
    prominent
  >
    <template v-slot:img="{ props }">
      <v-img
        v-bind="props"
        gradient="to bottom, rgba(96, 96, 96, 0.79), rgba(185, 185, 185, 0.5)"
      />
    </template>

    <v-btn
      v-if="$currentUser"
      icon
      color="white"
      @click="$router.push({ name: 'trips' })"
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>

    <v-toolbar-title class="white--text pl-0">
      {{ trip.name }}
    </v-toolbar-title>

    <v-spacer />

    <dialog-share-trip :trip="trip" />

    <the-user-menu />
  </v-app-bar>
</template>

<script>
import DialogShareTrip from '@/components/DialogShareTrip'
import TheUserMenu from '@/components/TheUserMenu'
import Trip from '@/models/Trip'

export default {
  components: {
    DialogShareTrip,
    TheUserMenu
  },
  props: {
    trip: {
      type: Trip,
      default: new Trip(),
      required: true
    }
  }
}
</script>

<style>

</style>
